module.exports = __webpack_public_path__ + "static/media/gs.e239a98c.svg";